import { render, staticRenderFns } from "./PartnerLogos.vue?vue&type=template&id=1190c41e&scoped=true&"
import script from "./PartnerLogos.vue?vue&type=script&lang=js&"
export * from "./PartnerLogos.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLogos.vue?vue&type=style&index=0&id=1190c41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1190c41e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
